import Vue from "vue";
import VueRouter from "vue-router";
import beforeEach from "./beforeEach";

import Home from "../views/home/Home.vue";
import ChatBot from "../views/chatBot/ChatBot.vue";
import ChatCx from "../views/chatCx/ChatCx.vue";
import Attendance from "../views/attendance/Attendance.vue";
import Queue from "../views/queue/Queue.vue";
import QueueAppointment from "../views/queueAppointment/QueueAppointment.vue";
import RatingVue from "@/views/rating/Rating.vue";
import RatingFormVue from "@/views/rating/partials/RatingForm.vue";
import ChatHistoricVue from "@/views/chatHistoric/ChatHistoric.vue";
import AttendanceAuthorize from "@/views/attendanceAuthorize/AttendanceAuthorize.vue";
import Audience from "@/views/audience/Audience.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
  },
  {
    path: "/chat-bot",
    name: "ChatBot",
    component: ChatBot,
  },
  {
    path: "/chat-cx",
    name: "ChatCx",
    component: ChatCx,
  },
  {
    path: "/attendance/:id",
    name: "Attendance",
    component: Attendance,
  },
  {
    path: "/attendance/:id/authorize",
    name: "AttendanceAuthorize",
    component: AttendanceAuthorize,
  },
  {
    path: "/queue",
    name: "Queue",
    component: Queue,
  },
  {
    path: "/queue-appointments/:appointmentID",
    name: "QueueAppointment",
    component: QueueAppointment,
  },
  {
    path: "/rating/:attendanceID/:deskID",
    name: "Rating",
    component: RatingVue,
  },
  {
    path: "/rating-appointment/:appointmentID/:deskID",
    name: "RatingAppointment",
    component: RatingVue,
  },
  {
    path: "/rating-form/:attendanceID/:deskID",
    name: "RatingForm",
    component: RatingFormVue,
  },
  {
    path: "/rating-form-appointment/:appointmentID/:deskID",
    name: "RatingFormAppointment",
    component: RatingFormVue,
  },
  {
    path: "/historic",
    name: "Historic",
    component: ChatHistoricVue,
  },
  {
    path: "/audience",
    name: "Audience",
    component: Audience,
    children: [
      {
        path: "join/:entityID?",
        name: "JoinAudience",
        component: () =>
          import("../views/audience/children/joinAudience/JoinAudience.vue"),
      },
      {
        path: "queue",
        name: "QueueAudience",
        component: () =>
          import("../views/audience/children/queueAudience/QueueAudience.vue"),
      },
      {
        path: "chat",
        name: "ChatAudience",
        component: () =>
          import("../views/audience/children/chatAudience/ChatAudience.vue"),
      },
    ],
  },
  {
    path: "*",
    redirect: "/home",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(beforeEach);

export default router;
